import { PublicClientApplication } from "@azure/msal-browser";
import { apiScopes, loginRequest } from "@/config/azureEntraIdConfig";
import { getCurrentMsalAccount } from "@/utils/sessionIdentity";

/**
 * Helper function to get Azure access token from MSAL instance
 * This is used by axios interceptor to add token to API requests
 */
export const getAzureAccessToken = async (
  msalInstance: PublicClientApplication,
  scopes: string[] = apiScopes.length ? apiScopes : loginRequest.scopes
): Promise<string | null> => {
  try {
    // The active account is the identity the OneView session was established for
    const account = getCurrentMsalAccount(msalInstance);

    if (!account) {
      console.warn("No accounts found in MSAL instance");
      return null;
    }

    // Try to acquire token silently for the requested scopes
    const response = await msalInstance.acquireTokenSilent({
      scopes,
      account,
    });

    return response.accessToken;
  } catch (error) {
    console.error("Error acquiring token:", error);
    
    // If silent token acquisition fails, you might want to trigger interactive login
    // For now, we'll just return null and let the API call fail
    return null;
  }
};

/**
 * Check if user is authenticated in MSAL
 */
export const isUserAuthenticated = (msalInstance: PublicClientApplication): boolean => {
  return msalInstance.getAllAccounts().length > 0;
};

